export const BLOCK_POST_CLASSNAME = 'block-post';

export const WIDGET_COMMUNITY_POST_LIST_TYPE = 'community-post-list';
